/*
* Copyright (c) 2009-2022. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

// The DOM element `ChatIslandMount.vue` calls `mount(el, host)` on — shared with
// `ChatTopBarEntry.vue` (a SEPARATE Vue component, rendered in the navbar, not a descendant of the
// mount point) so its click handler can command `toggleDock(el)` (`@zaya-chat/ui-react`'s
// package-level API, M2). Plain singleton, same pattern as `chatBadgeState.js` — IMS has exactly
// one chat mount for the whole app lifetime, so a module-level ref is sufficient (no Vuex needed).
let mountEl = null;

export function setChatMountEl(el) {
  mountEl = el;
}

export function getChatMountEl() {
  return mountEl;
}
